import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SubmitButton from 'components/SubmitButton'

const DeleteModal = ({ closeModal, deleteAction, title, message, messageHTML, cancelText, deleteText, loadingText, style, isLoading: externalIsLoading }) => {
  const { t } = useTranslation()
  const [isDeleting, setIsDeleting] = useState(false)
  const isLoading = externalIsLoading || isDeleting

  const handleDelete = async () => {
    if (isLoading) return
    setIsDeleting(true)
    try {
      await deleteAction()
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <div className="modal-content" style={style}>
      <div className="modal-header">
        <h5
          className="modal-title"
        >{title}</h5>
        <button type="button" className="btn-close" aria-label={t('common.close')} onClick={closeModal} disabled={isLoading}></button>
      </div>
      <div className="modal-body">

        {message &&
          <p>{message}</p>
        }

        {messageHTML &&
          <div className="modal-HTML-text" dangerouslySetInnerHTML={{ __html: messageHTML }}></div>
        }

      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-outline-primary" onClick={closeModal} disabled={isLoading}>{cancelText || t('common.cancel')}</button>
        <SubmitButton
          type="button"
          variant="danger"
          onClick={handleDelete}
          isLoading={isLoading}
          text={deleteText || t('common.delete')}
          loadingText={loadingText || t('common.deleting')}
        />
      </div>
    </div>
  )
}

export default DeleteModal
